import { isRouteErrorResponse, Link, Outlet, useRouteError } from 'react-router';
import DashboardLayout from './layout/dashboard-layout';

/** The signed-in frame — sidebar, search, toasts — around the current screen. */
export function DashboardShell() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}

function Notice({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <h1 className="text-[22px] font-bold tracking-tight text-white">{title}</h1>
      <div className="mt-2 space-y-4 text-[13px] text-zinc-500">{children}</div>
    </div>
  );
}

/** Shown for anything a loader or screen throws: 404s and real errors. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <Notice title="Not found">
        <p>This page does not exist, or the record was removed.</p>
        <Link to="/admin" className="text-emerald-400 hover:underline">Back to the dashboard</Link>
      </Notice>
    );
  }
  const message = error instanceof Error ? error.message : 'Something went wrong.';
  return (
    <Notice title="Could not load this page">
      <p>{message}</p>
      <button onClick={() => window.location.reload()} className="text-emerald-400 hover:underline">
        Try again
      </button>
    </Notice>
  );
}
